module.exports = __webpack_public_path__ + "img/hands-holding-heart.0a327c5b.svg";